(ns livefeed.state
  (:require [reagent.core :as reagent]))

(defonce logged-in (reagent/atom nil))

;; User from websocket api
(defonce user (reagent/atom {}))

;; User from tunnus-sdk
(defonce tunnus-user (reagent/atom {}))

(defonce tunnus (reagent/atom nil))

(defonce tunnus-broadcast-channel (atom nil))

(defonce is-at-bottom (atom false))

(defonce feed-reactions (reagent/atom nil))

(defonce best-view-enabled? (reagent/atom false))

(defonce analytics-event (atom "ylechat"))

(defonce theme (atom "chat"))

(defonce label (reagent/atom nil))

(defonce input-value (reagent/atom ""))

(defonce input-focused? (reagent/atom false))

(defonce locked? (reagent/atom false))

(defonce initialized? (reagent/atom false))

(defonce emojis (atom nil))

(defonce topic-title (atom nil))

(defonce topic-description (atom nil))

(defonce topic-id (atom nil))

(defonce use-chat-public-input (reagent/atom nil))

(defonce use-chat-public-report (reagent/atom nil))

(defonce use-chat-public-description (reagent/atom nil))

(defonce use-chat-public-reactions (reagent/atom nil))

(defonce use-chat-public-message-feed (reagent/atom nil))

